import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import io.github.retar.portfolio.components.layouts.PageLayout as _io_github_retar_portfolio_components_layouts_PageLayout
import io.github.retar.portfolio.pages.Appsflyer_kmpPage as _io_github_retar_portfolio_pages_Appsflyer_kmpPage
import io.github.retar.portfolio.pages.Epub_read_along_media3Page as _io_github_retar_portfolio_pages_Epub_read_along_media3Page
import io.github.retar.portfolio.pages.IndexPage as _io_github_retar_portfolio_pages_IndexPage
import io.github.retar.portfolio.pages.Infinite_carousel_kobwebPage as _io_github_retar_portfolio_pages_Infinite_carousel_kobwebPage
import io.github.retar.portfolio.pages.MarkdownPage as _io_github_retar_portfolio_pages_MarkdownPage
import io.github.retar.portfolio.pages.NowPage as _io_github_retar_portfolio_pages_NowPage
import io.github.retar.portfolio.pages.On_device_tts_sherpa_onnxPage as _io_github_retar_portfolio_pages_On_device_tts_sherpa_onnxPage
import io.github.retar.portfolio.pages.Opds_hostile_inputPage as _io_github_retar_portfolio_pages_Opds_hostile_inputPage
import io.github.retar.portfolio.pages.ParrotPage as _io_github_retar_portfolio_pages_ParrotPage
import io.github.retar.portfolio.pages.Parrot_in_the_browserPage as _io_github_retar_portfolio_pages_Parrot_in_the_browserPage
import io.github.retar.portfolio.pages.Password_managers_compose_webPage as _io_github_retar_portfolio_pages_Password_managers_compose_webPage
import io.github.retar.portfolio.pages.Static_kotlin_native_sqlcipherPage as _io_github_retar_portfolio_pages_Static_kotlin_native_sqlcipherPage
import io.github.retar.portfolio.pages.Syncing_reading_positionsPage as _io_github_retar_portfolio_pages_Syncing_reading_positionsPage
import io.github.retar.portfolio.pages.Tts_shared_kotlin_onnxPage as _io_github_retar_portfolio_pages_Tts_shared_kotlin_onnxPage
import io.github.retar.portfolio.pages.UsesPage as _io_github_retar_portfolio_pages_UsesPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Rok Retar"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _io_github_retar_portfolio_components_layouts_PageLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "io.github.retar.portfolio.pages.MarkdownPage",
            parentLayoutId = "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _io_github_retar_portfolio_pages_MarkdownPage {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_IndexPage()
        }
        ctx.router.register(
            "/blog/android-app-in-the-browser-kotlin-wasm",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initParrot_in_the_browserPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Parrot_in_the_browserPage()
        }
        ctx.router.register(
            "/blog/appsflyer-kmp-wrapper",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initAppsflyer_kmpPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Appsflyer_kmpPage()
        }
        ctx.router.register(
            "/blog/epub-read-along-media3",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initEpub_read_along_media3Page(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Epub_read_along_media3Page()
        }
        ctx.router.register(
            "/blog/infinite-carousel",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initInfinite_carousel_kobwebPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Infinite_carousel_kobwebPage()
        }
        ctx.router.register(
            "/blog/kokoro-tts-shared-kotlin-onnx-runtime",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initTts_shared_kotlin_onnxPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Tts_shared_kotlin_onnxPage()
        }
        ctx.router.register(
            "/blog/on-device-neural-tts-android",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initOn_device_tts_sherpa_onnxPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_On_device_tts_sherpa_onnxPage()
        }
        ctx.router.register(
            "/blog/opds-catalogue-client-kotlin-multiplatform",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initOpds_hostile_inputPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Opds_hostile_inputPage()
        }
        ctx.router.register(
            "/blog/password-managers-compose-multiplatform-web",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initPassword_managers_compose_webPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Password_managers_compose_webPage()
        }
        ctx.router.register(
            "/blog/sqlcipher-static-kotlin-native-framework",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initStatic_kotlin_native_sqlcipherPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Static_kotlin_native_sqlcipherPage()
        }
        ctx.router.register(
            "/blog/syncing-reading-positions",
            layoutId = "io.github.retar.portfolio.pages.MarkdownPage",
            initRouteMethod = { ctx ->
                io.github.retar.portfolio.pages.initSyncing_reading_positionsPage(ctx)
            },
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_Syncing_reading_positionsPage()
        }
        ctx.router.register(
            "/now",
            layoutId = "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_NowPage()
        }
        ctx.router.register(
            "/parrot",
            layoutId = "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_ParrotPage()
        }
        ctx.router.register(
            "/uses",
            layoutId = "io.github.retar.portfolio.components.layouts.PageLayout",
        ) { pageCtx -> 
            _io_github_retar_portfolio_pages_UsesPage()
        }

        io.github.retar.portfolio.initRouter(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer-link", io.github.retar.portfolio.components.footer.FooterLinkStyle)
        ctx.theme.registerStyle("footer-container", io.github.retar.portfolio.components.footer.FooterContainerStyle)
        ctx.theme.registerStyle("menu-icon", io.github.retar.portfolio.components.header.MenuIconStyle)
        ctx.theme.registerStyle("dropdown", io.github.retar.portfolio.components.header.DropdownStyle)
        ctx.theme.registerStyle("nav-link", io.github.retar.portfolio.components.header.NavLinkStyle)
        ctx.theme.registerStyle("profile-image", io.github.retar.portfolio.components.header.ProfileImageStyle)
        ctx.theme.registerStyle("page-content", io.github.retar.portfolio.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("nav-header", io.github.retar.portfolio.components.layouts.NavHeaderStyle)
        ctx.theme.registerStyle("callout", io.github.retar.portfolio.components.widgets.CalloutStyle)
        ctx.theme.registerStyle("inline-code", io.github.retar.portfolio.components.widgets.InlineCodeStyle)
        ctx.theme.registerStyle("code-block", io.github.retar.portfolio.components.widgets.CodeBlockStyle)
        ctx.theme.registerStyle("code-label", io.github.retar.portfolio.components.widgets.CodeLabelStyle)
        ctx.theme.registerStyle("text-link", io.github.retar.portfolio.components.widgets.TextLinkStyle)
        ctx.theme.registerStyle("button-link", io.github.retar.portfolio.components.widgets.ButtonLinkStyle)
        ctx.theme.registerStyle("outline-button", io.github.retar.portfolio.components.widgets.OutlineButtonStyle)
        ctx.theme.registerStyle("primary-button", io.github.retar.portfolio.components.widgets.PrimaryButtonStyle)
        ctx.theme.registerStyle("editorial-grid", io.github.retar.portfolio.components.widgets.EditorialGridStyle)
        ctx.theme.registerStyle("phone-frame", io.github.retar.portfolio.components.widgets.PhoneFrameStyle)
        ctx.theme.registerStyle("phone-row", io.github.retar.portfolio.components.widgets.PhoneRowStyle)
        ctx.theme.registerStyle("phone-row-item", io.github.retar.portfolio.components.widgets.PhoneRowItemStyle)
        ctx.theme.registerStyle("fact-list", io.github.retar.portfolio.components.widgets.FactListStyle)
        ctx.theme.registerStyle("fact", io.github.retar.portfolio.components.widgets.FactStyle)
        ctx.theme.registerStyle("article-row", io.github.retar.portfolio.components.widgets.ArticleRowStyle)
        ctx.theme.registerStyle("hero-grid", io.github.retar.portfolio.pages.HeroGridStyle)
        ctx.theme.registerStyle("hero-portrait", io.github.retar.portfolio.pages.HeroPortraitStyle)
        ctx.theme.registerStyle("heading-link", io.github.retar.portfolio.pages.HeadingLinkStyle)
        ctx.theme.registerStyle("phone-link", io.github.retar.portfolio.pages.PhoneLinkStyle)
        ctx.theme.registerStyle("timeline-row", io.github.retar.portfolio.pages.TimelineRowStyle)
        ctx.theme.registerStyle("parrot-hero", io.github.retar.portfolio.pages.ParrotHeroStyle)
        ctx.theme.registerStyle("parrot-hero-phone", io.github.retar.portfolio.pages.ParrotHeroPhoneStyle)
        ctx.theme.registerStyle("release-row", io.github.retar.portfolio.pages.ReleaseRowStyle)
        ctx.theme.registerStyle("display", io.github.retar.portfolio.styles.DisplayStyle)
        ctx.theme.registerStyle("h1", io.github.retar.portfolio.styles.H1Style)
        ctx.theme.registerStyle("h2", io.github.retar.portfolio.styles.H2Style)
        ctx.theme.registerStyle("h3", io.github.retar.portfolio.styles.H3Style)
        ctx.theme.registerStyle("body", io.github.retar.portfolio.styles.BodyStyle)
        ctx.theme.registerStyle("body-small", io.github.retar.portfolio.styles.BodySmallStyle)
        ctx.theme.registerStyle("mono-eyebrow", io.github.retar.portfolio.styles.MonoEyebrowStyle)
        ctx.theme.registerStyle("mono-label", io.github.retar.portfolio.styles.MonoLabelStyle)
        ctx.theme.registerStyle("caption", io.github.retar.portfolio.styles.CaptionStyle)
        ctx.theme.registerStyle("label", io.github.retar.portfolio.styles.LabelStyle)
        ctx.theme.registerStyle("subtitle", io.github.retar.portfolio.styles.SubtitleStyle)
        ctx.theme.registerStyle("descriptor", io.github.retar.portfolio.styles.DescriptorStyle)
        ctx.theme.registerStyle("mono-accent", io.github.retar.portfolio.styles.MonoAccentStyle)
        ctx.theme.registerKeyframes("theme-toggle-spin", io.github.retar.portfolio.components.header.ThemeToggleSpinKeyframes)
        ctx.theme.registerKeyframes("mobile-nav-slide-down", io.github.retar.portfolio.components.header.MobileNavSlideDownKeyframes)
        io.github.retar.portfolio.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        io.github.retar.portfolio.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
